// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';



export class BallHitDataWire implements flatbuffers.IUnpackableObject<BallHitDataWireT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):BallHitDataWire {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsBallHitDataWire(bb:flatbuffers.ByteBuffer, obj?:BallHitDataWire):BallHitDataWire {
  return (obj || new BallHitDataWire()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsBallHitDataWire(bb:flatbuffers.ByteBuffer, obj?:BallHitDataWire):BallHitDataWire {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new BallHitDataWire()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

speed():number {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

angle():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

direction():number {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

distance():number {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

actualDistance():number {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

projectedX():number {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

projectedY():number {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

projectedZ():number {
  const offset = this.bb!.__offset(this.bb_pos, 18);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

actualX():number {
  const offset = this.bb!.__offset(this.bb_pos, 20);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

actualY():number {
  const offset = this.bb!.__offset(this.bb_pos, 22);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

actualZ():number {
  const offset = this.bb!.__offset(this.bb_pos, 24);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

polynomialX1():number {
  const offset = this.bb!.__offset(this.bb_pos, 26);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

polynomialX2():number {
  const offset = this.bb!.__offset(this.bb_pos, 28);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

polynomialX3():number {
  const offset = this.bb!.__offset(this.bb_pos, 30);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

polynomialX4():number {
  const offset = this.bb!.__offset(this.bb_pos, 32);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

polynomialX5():number {
  const offset = this.bb!.__offset(this.bb_pos, 34);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

polynomialX6():number {
  const offset = this.bb!.__offset(this.bb_pos, 36);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

polynomialX7():number {
  const offset = this.bb!.__offset(this.bb_pos, 38);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

polynomialX8():number {
  const offset = this.bb!.__offset(this.bb_pos, 40);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

polynomialX9():number {
  const offset = this.bb!.__offset(this.bb_pos, 42);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

polynomialY1():number {
  const offset = this.bb!.__offset(this.bb_pos, 44);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

polynomialY2():number {
  const offset = this.bb!.__offset(this.bb_pos, 46);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

polynomialY3():number {
  const offset = this.bb!.__offset(this.bb_pos, 48);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

polynomialY4():number {
  const offset = this.bb!.__offset(this.bb_pos, 50);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

polynomialY5():number {
  const offset = this.bb!.__offset(this.bb_pos, 52);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

polynomialY6():number {
  const offset = this.bb!.__offset(this.bb_pos, 54);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

polynomialY7():number {
  const offset = this.bb!.__offset(this.bb_pos, 56);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

polynomialY8():number {
  const offset = this.bb!.__offset(this.bb_pos, 58);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

polynomialY9():number {
  const offset = this.bb!.__offset(this.bb_pos, 60);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

polynomialZ1():number {
  const offset = this.bb!.__offset(this.bb_pos, 62);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

polynomialZ2():number {
  const offset = this.bb!.__offset(this.bb_pos, 64);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

polynomialZ3():number {
  const offset = this.bb!.__offset(this.bb_pos, 66);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

polynomialZ4():number {
  const offset = this.bb!.__offset(this.bb_pos, 68);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

polynomialZ5():number {
  const offset = this.bb!.__offset(this.bb_pos, 70);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

polynomialZ6():number {
  const offset = this.bb!.__offset(this.bb_pos, 72);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

polynomialZ7():number {
  const offset = this.bb!.__offset(this.bb_pos, 74);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

polynomialZ8():number {
  const offset = this.bb!.__offset(this.bb_pos, 76);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

polynomialZ9():number {
  const offset = this.bb!.__offset(this.bb_pos, 78);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

startTime():number {
  const offset = this.bb!.__offset(this.bb_pos, 80);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

endTime():number {
  const offset = this.bb!.__offset(this.bb_pos, 82);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

landingTime():number {
  const offset = this.bb!.__offset(this.bb_pos, 84);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

static startBallHitDataWire(builder:flatbuffers.Builder) {
  builder.startObject(41);
}

static addSpeed(builder:flatbuffers.Builder, speed:number) {
  builder.addFieldFloat32(0, speed, 0.0);
}

static addAngle(builder:flatbuffers.Builder, angle:number) {
  builder.addFieldFloat32(1, angle, 0.0);
}

static addDirection(builder:flatbuffers.Builder, direction:number) {
  builder.addFieldFloat32(2, direction, 0.0);
}

static addDistance(builder:flatbuffers.Builder, distance:number) {
  builder.addFieldFloat32(3, distance, 0.0);
}

static addActualDistance(builder:flatbuffers.Builder, actualDistance:number) {
  builder.addFieldFloat32(4, actualDistance, 0.0);
}

static addProjectedX(builder:flatbuffers.Builder, projectedX:number) {
  builder.addFieldFloat32(5, projectedX, 0.0);
}

static addProjectedY(builder:flatbuffers.Builder, projectedY:number) {
  builder.addFieldFloat32(6, projectedY, 0.0);
}

static addProjectedZ(builder:flatbuffers.Builder, projectedZ:number) {
  builder.addFieldFloat32(7, projectedZ, 0.0);
}

static addActualX(builder:flatbuffers.Builder, actualX:number) {
  builder.addFieldFloat32(8, actualX, 0.0);
}

static addActualY(builder:flatbuffers.Builder, actualY:number) {
  builder.addFieldFloat32(9, actualY, 0.0);
}

static addActualZ(builder:flatbuffers.Builder, actualZ:number) {
  builder.addFieldFloat32(10, actualZ, 0.0);
}

static addPolynomialX1(builder:flatbuffers.Builder, polynomialX1:number) {
  builder.addFieldFloat32(11, polynomialX1, 0.0);
}

static addPolynomialX2(builder:flatbuffers.Builder, polynomialX2:number) {
  builder.addFieldFloat32(12, polynomialX2, 0.0);
}

static addPolynomialX3(builder:flatbuffers.Builder, polynomialX3:number) {
  builder.addFieldFloat32(13, polynomialX3, 0.0);
}

static addPolynomialX4(builder:flatbuffers.Builder, polynomialX4:number) {
  builder.addFieldFloat32(14, polynomialX4, 0.0);
}

static addPolynomialX5(builder:flatbuffers.Builder, polynomialX5:number) {
  builder.addFieldFloat32(15, polynomialX5, 0.0);
}

static addPolynomialX6(builder:flatbuffers.Builder, polynomialX6:number) {
  builder.addFieldFloat32(16, polynomialX6, 0.0);
}

static addPolynomialX7(builder:flatbuffers.Builder, polynomialX7:number) {
  builder.addFieldFloat32(17, polynomialX7, 0.0);
}

static addPolynomialX8(builder:flatbuffers.Builder, polynomialX8:number) {
  builder.addFieldFloat32(18, polynomialX8, 0.0);
}

static addPolynomialX9(builder:flatbuffers.Builder, polynomialX9:number) {
  builder.addFieldFloat32(19, polynomialX9, 0.0);
}

static addPolynomialY1(builder:flatbuffers.Builder, polynomialY1:number) {
  builder.addFieldFloat32(20, polynomialY1, 0.0);
}

static addPolynomialY2(builder:flatbuffers.Builder, polynomialY2:number) {
  builder.addFieldFloat32(21, polynomialY2, 0.0);
}

static addPolynomialY3(builder:flatbuffers.Builder, polynomialY3:number) {
  builder.addFieldFloat32(22, polynomialY3, 0.0);
}

static addPolynomialY4(builder:flatbuffers.Builder, polynomialY4:number) {
  builder.addFieldFloat32(23, polynomialY4, 0.0);
}

static addPolynomialY5(builder:flatbuffers.Builder, polynomialY5:number) {
  builder.addFieldFloat32(24, polynomialY5, 0.0);
}

static addPolynomialY6(builder:flatbuffers.Builder, polynomialY6:number) {
  builder.addFieldFloat32(25, polynomialY6, 0.0);
}

static addPolynomialY7(builder:flatbuffers.Builder, polynomialY7:number) {
  builder.addFieldFloat32(26, polynomialY7, 0.0);
}

static addPolynomialY8(builder:flatbuffers.Builder, polynomialY8:number) {
  builder.addFieldFloat32(27, polynomialY8, 0.0);
}

static addPolynomialY9(builder:flatbuffers.Builder, polynomialY9:number) {
  builder.addFieldFloat32(28, polynomialY9, 0.0);
}

static addPolynomialZ1(builder:flatbuffers.Builder, polynomialZ1:number) {
  builder.addFieldFloat32(29, polynomialZ1, 0.0);
}

static addPolynomialZ2(builder:flatbuffers.Builder, polynomialZ2:number) {
  builder.addFieldFloat32(30, polynomialZ2, 0.0);
}

static addPolynomialZ3(builder:flatbuffers.Builder, polynomialZ3:number) {
  builder.addFieldFloat32(31, polynomialZ3, 0.0);
}

static addPolynomialZ4(builder:flatbuffers.Builder, polynomialZ4:number) {
  builder.addFieldFloat32(32, polynomialZ4, 0.0);
}

static addPolynomialZ5(builder:flatbuffers.Builder, polynomialZ5:number) {
  builder.addFieldFloat32(33, polynomialZ5, 0.0);
}

static addPolynomialZ6(builder:flatbuffers.Builder, polynomialZ6:number) {
  builder.addFieldFloat32(34, polynomialZ6, 0.0);
}

static addPolynomialZ7(builder:flatbuffers.Builder, polynomialZ7:number) {
  builder.addFieldFloat32(35, polynomialZ7, 0.0);
}

static addPolynomialZ8(builder:flatbuffers.Builder, polynomialZ8:number) {
  builder.addFieldFloat32(36, polynomialZ8, 0.0);
}

static addPolynomialZ9(builder:flatbuffers.Builder, polynomialZ9:number) {
  builder.addFieldFloat32(37, polynomialZ9, 0.0);
}

static addStartTime(builder:flatbuffers.Builder, startTime:number) {
  builder.addFieldFloat32(38, startTime, 0.0);
}

static addEndTime(builder:flatbuffers.Builder, endTime:number) {
  builder.addFieldFloat32(39, endTime, 0.0);
}

static addLandingTime(builder:flatbuffers.Builder, landingTime:number) {
  builder.addFieldFloat32(40, landingTime, 0.0);
}

static endBallHitDataWire(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createBallHitDataWire(builder:flatbuffers.Builder, speed:number, angle:number, direction:number, distance:number, actualDistance:number, projectedX:number, projectedY:number, projectedZ:number, actualX:number, actualY:number, actualZ:number, polynomialX1:number, polynomialX2:number, polynomialX3:number, polynomialX4:number, polynomialX5:number, polynomialX6:number, polynomialX7:number, polynomialX8:number, polynomialX9:number, polynomialY1:number, polynomialY2:number, polynomialY3:number, polynomialY4:number, polynomialY5:number, polynomialY6:number, polynomialY7:number, polynomialY8:number, polynomialY9:number, polynomialZ1:number, polynomialZ2:number, polynomialZ3:number, polynomialZ4:number, polynomialZ5:number, polynomialZ6:number, polynomialZ7:number, polynomialZ8:number, polynomialZ9:number, startTime:number, endTime:number, landingTime:number):flatbuffers.Offset {
  BallHitDataWire.startBallHitDataWire(builder);
  BallHitDataWire.addSpeed(builder, speed);
  BallHitDataWire.addAngle(builder, angle);
  BallHitDataWire.addDirection(builder, direction);
  BallHitDataWire.addDistance(builder, distance);
  BallHitDataWire.addActualDistance(builder, actualDistance);
  BallHitDataWire.addProjectedX(builder, projectedX);
  BallHitDataWire.addProjectedY(builder, projectedY);
  BallHitDataWire.addProjectedZ(builder, projectedZ);
  BallHitDataWire.addActualX(builder, actualX);
  BallHitDataWire.addActualY(builder, actualY);
  BallHitDataWire.addActualZ(builder, actualZ);
  BallHitDataWire.addPolynomialX1(builder, polynomialX1);
  BallHitDataWire.addPolynomialX2(builder, polynomialX2);
  BallHitDataWire.addPolynomialX3(builder, polynomialX3);
  BallHitDataWire.addPolynomialX4(builder, polynomialX4);
  BallHitDataWire.addPolynomialX5(builder, polynomialX5);
  BallHitDataWire.addPolynomialX6(builder, polynomialX6);
  BallHitDataWire.addPolynomialX7(builder, polynomialX7);
  BallHitDataWire.addPolynomialX8(builder, polynomialX8);
  BallHitDataWire.addPolynomialX9(builder, polynomialX9);
  BallHitDataWire.addPolynomialY1(builder, polynomialY1);
  BallHitDataWire.addPolynomialY2(builder, polynomialY2);
  BallHitDataWire.addPolynomialY3(builder, polynomialY3);
  BallHitDataWire.addPolynomialY4(builder, polynomialY4);
  BallHitDataWire.addPolynomialY5(builder, polynomialY5);
  BallHitDataWire.addPolynomialY6(builder, polynomialY6);
  BallHitDataWire.addPolynomialY7(builder, polynomialY7);
  BallHitDataWire.addPolynomialY8(builder, polynomialY8);
  BallHitDataWire.addPolynomialY9(builder, polynomialY9);
  BallHitDataWire.addPolynomialZ1(builder, polynomialZ1);
  BallHitDataWire.addPolynomialZ2(builder, polynomialZ2);
  BallHitDataWire.addPolynomialZ3(builder, polynomialZ3);
  BallHitDataWire.addPolynomialZ4(builder, polynomialZ4);
  BallHitDataWire.addPolynomialZ5(builder, polynomialZ5);
  BallHitDataWire.addPolynomialZ6(builder, polynomialZ6);
  BallHitDataWire.addPolynomialZ7(builder, polynomialZ7);
  BallHitDataWire.addPolynomialZ8(builder, polynomialZ8);
  BallHitDataWire.addPolynomialZ9(builder, polynomialZ9);
  BallHitDataWire.addStartTime(builder, startTime);
  BallHitDataWire.addEndTime(builder, endTime);
  BallHitDataWire.addLandingTime(builder, landingTime);
  return BallHitDataWire.endBallHitDataWire(builder);
}

unpack(): BallHitDataWireT {
  return new BallHitDataWireT(
    this.speed(),
    this.angle(),
    this.direction(),
    this.distance(),
    this.actualDistance(),
    this.projectedX(),
    this.projectedY(),
    this.projectedZ(),
    this.actualX(),
    this.actualY(),
    this.actualZ(),
    this.polynomialX1(),
    this.polynomialX2(),
    this.polynomialX3(),
    this.polynomialX4(),
    this.polynomialX5(),
    this.polynomialX6(),
    this.polynomialX7(),
    this.polynomialX8(),
    this.polynomialX9(),
    this.polynomialY1(),
    this.polynomialY2(),
    this.polynomialY3(),
    this.polynomialY4(),
    this.polynomialY5(),
    this.polynomialY6(),
    this.polynomialY7(),
    this.polynomialY8(),
    this.polynomialY9(),
    this.polynomialZ1(),
    this.polynomialZ2(),
    this.polynomialZ3(),
    this.polynomialZ4(),
    this.polynomialZ5(),
    this.polynomialZ6(),
    this.polynomialZ7(),
    this.polynomialZ8(),
    this.polynomialZ9(),
    this.startTime(),
    this.endTime(),
    this.landingTime()
  );
}


unpackTo(_o: BallHitDataWireT): void {
  _o.speed = this.speed();
  _o.angle = this.angle();
  _o.direction = this.direction();
  _o.distance = this.distance();
  _o.actualDistance = this.actualDistance();
  _o.projectedX = this.projectedX();
  _o.projectedY = this.projectedY();
  _o.projectedZ = this.projectedZ();
  _o.actualX = this.actualX();
  _o.actualY = this.actualY();
  _o.actualZ = this.actualZ();
  _o.polynomialX1 = this.polynomialX1();
  _o.polynomialX2 = this.polynomialX2();
  _o.polynomialX3 = this.polynomialX3();
  _o.polynomialX4 = this.polynomialX4();
  _o.polynomialX5 = this.polynomialX5();
  _o.polynomialX6 = this.polynomialX6();
  _o.polynomialX7 = this.polynomialX7();
  _o.polynomialX8 = this.polynomialX8();
  _o.polynomialX9 = this.polynomialX9();
  _o.polynomialY1 = this.polynomialY1();
  _o.polynomialY2 = this.polynomialY2();
  _o.polynomialY3 = this.polynomialY3();
  _o.polynomialY4 = this.polynomialY4();
  _o.polynomialY5 = this.polynomialY5();
  _o.polynomialY6 = this.polynomialY6();
  _o.polynomialY7 = this.polynomialY7();
  _o.polynomialY8 = this.polynomialY8();
  _o.polynomialY9 = this.polynomialY9();
  _o.polynomialZ1 = this.polynomialZ1();
  _o.polynomialZ2 = this.polynomialZ2();
  _o.polynomialZ3 = this.polynomialZ3();
  _o.polynomialZ4 = this.polynomialZ4();
  _o.polynomialZ5 = this.polynomialZ5();
  _o.polynomialZ6 = this.polynomialZ6();
  _o.polynomialZ7 = this.polynomialZ7();
  _o.polynomialZ8 = this.polynomialZ8();
  _o.polynomialZ9 = this.polynomialZ9();
  _o.startTime = this.startTime();
  _o.endTime = this.endTime();
  _o.landingTime = this.landingTime();
}
}

export class BallHitDataWireT implements flatbuffers.IGeneratedObject {
constructor(
  public speed: number = 0.0,
  public angle: number = 0.0,
  public direction: number = 0.0,
  public distance: number = 0.0,
  public actualDistance: number = 0.0,
  public projectedX: number = 0.0,
  public projectedY: number = 0.0,
  public projectedZ: number = 0.0,
  public actualX: number = 0.0,
  public actualY: number = 0.0,
  public actualZ: number = 0.0,
  public polynomialX1: number = 0.0,
  public polynomialX2: number = 0.0,
  public polynomialX3: number = 0.0,
  public polynomialX4: number = 0.0,
  public polynomialX5: number = 0.0,
  public polynomialX6: number = 0.0,
  public polynomialX7: number = 0.0,
  public polynomialX8: number = 0.0,
  public polynomialX9: number = 0.0,
  public polynomialY1: number = 0.0,
  public polynomialY2: number = 0.0,
  public polynomialY3: number = 0.0,
  public polynomialY4: number = 0.0,
  public polynomialY5: number = 0.0,
  public polynomialY6: number = 0.0,
  public polynomialY7: number = 0.0,
  public polynomialY8: number = 0.0,
  public polynomialY9: number = 0.0,
  public polynomialZ1: number = 0.0,
  public polynomialZ2: number = 0.0,
  public polynomialZ3: number = 0.0,
  public polynomialZ4: number = 0.0,
  public polynomialZ5: number = 0.0,
  public polynomialZ6: number = 0.0,
  public polynomialZ7: number = 0.0,
  public polynomialZ8: number = 0.0,
  public polynomialZ9: number = 0.0,
  public startTime: number = 0.0,
  public endTime: number = 0.0,
  public landingTime: number = 0.0
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return BallHitDataWire.createBallHitDataWire(builder,
    this.speed,
    this.angle,
    this.direction,
    this.distance,
    this.actualDistance,
    this.projectedX,
    this.projectedY,
    this.projectedZ,
    this.actualX,
    this.actualY,
    this.actualZ,
    this.polynomialX1,
    this.polynomialX2,
    this.polynomialX3,
    this.polynomialX4,
    this.polynomialX5,
    this.polynomialX6,
    this.polynomialX7,
    this.polynomialX8,
    this.polynomialX9,
    this.polynomialY1,
    this.polynomialY2,
    this.polynomialY3,
    this.polynomialY4,
    this.polynomialY5,
    this.polynomialY6,
    this.polynomialY7,
    this.polynomialY8,
    this.polynomialY9,
    this.polynomialZ1,
    this.polynomialZ2,
    this.polynomialZ3,
    this.polynomialZ4,
    this.polynomialZ5,
    this.polynomialZ6,
    this.polynomialZ7,
    this.polynomialZ8,
    this.polynomialZ9,
    this.startTime,
    this.endTime,
    this.landingTime
  );
}
}
